import type { StorageLike } from "../game/local-store";
import type { SyncBase } from "./sync";

const KEY = "zookeepbit.syncbase";

/** The sync base in the browser's storage. Anything missing, broken or odd counts as no base (the sync then asks the player when games differ). */
export function createBaseStore(storage: StorageLike | null): { load(): SyncBase | null; save(base: SyncBase | null): void } {
  return {
    load() {
      try {
        const raw = storage?.getItem(KEY);
        if (!raw) return null;
        const v = JSON.parse(raw) as Partial<SyncBase> | null;
        if (v && typeof v.username === "string" && typeof v.text === "string" && typeof v.revision === "number" && Number.isInteger(v.revision)) {
          return { username: v.username, revision: v.revision, text: v.text };
        }
      } catch {
        // unreadable: no base
      }
      return null;
    },
    save(base) {
      try {
        if (base === null) storage?.removeItem(KEY);
        else storage?.setItem(KEY, JSON.stringify(base));
      } catch {
        // No room or no storage: the next start may ask the player once more.
      }
    },
  };
}
